module.exports = __webpack_public_path__ + "img/remenbiaoqian.0924bb41.png";